import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SharedService } from '../../_service/shared.service';
import { DentalService } from '../../_service/dental.service';
import {PageEvent,MatPaginator} from '@angular/material/paginator';
import * as XLSX from 'xlsx';
import {formatDate} from '@angular/common';
@Component({
  selector: 'app-plan-out-history',
  templateUrl: './plan-out-history.component.html',
  styleUrls: ['./plan-out-history.component.css']
})
export class PlanOutHistoryComponent implements OnInit {

  @ViewChild('paginatorBottom', {static: false}) paginatorBottom: MatPaginator;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef;

  @ViewChild('planSentDateRangeStart', {static: false}) planSentDateRangeStart: ElementRef;
  @ViewChild('planSentDateRangeEnd', {static: false}) planSentDateRangeEnd: ElementRef;

  @ViewChild('odsplanSentDateRangeStart', {static: false}) odsplanSentDateRangeStart: ElementRef;
  @ViewChild('odsplanSentDateRangeEnd', {static: false}) odsplanSentDateRangeEnd: ElementRef;

  @ViewChild('snazzyplanSentDateRangeStart', {static: false}) snazzyplanSentDateRangeStart: ElementRef;
  @ViewChild('snazzyplanSentDateRangeEnd', {static: false}) snazzyplanSentDateRangeEnd: ElementRef;

  @ViewChild('sofDateRangeStart', {static: false}) sofDateRangeStart: ElementRef;
  @ViewChild('sofDateRangeEnd', {static: false}) sofDateRangeEnd: ElementRef;

  @ViewChild('productionDateRangeStart', {static: false}) productionDateRangeStart: ElementRef;
  @ViewChild('productionDateRangeEnd', {static: false}) productionDateRangeEnd: ElementRef;

  @ViewChild('ardDateRangeStart', {static: false}) ardDateRangeStart: ElementRef;
  @ViewChild('ardDateRangeEnd', {static: false}) ardDateRangeEnd: ElementRef;

  perpage:number=10;length:number=0;pageEvent: PageEvent; pageSizeOptions = [10,25,50,100]; pageIndex:number=0;

  search:string;  start_date:string=''; end_date:string=''; preplan_loading = false;preplan_loaded = true;preplanCustomerLists = [];
  plan_sent_search:string; paln_sent_start_date:string=''; paln_sent_end_date:string=''; plan_sent_loading = true; plan_sent_loaded = false;
  planSentLists = []; ods_start_date:string=''; ods_end_date:string=''; snazzy_start_date:string=''; snazzy_end_date:string='';
  sof_start_date:string=''; sof_end_date:string=''; production_start_date:string=''; production_end_date:string=''; ard_start_date:string=''; ard_end_date:string='';
  maxDate = new Date();
  constructor(private sharedapi:SharedService, private dentalapi:DentalService) { }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.searchPlanSent(0,this.perpage);
  }

  dateRangeChange(date1,date2)
  {
      if(date2.value)
      {
          this.start_date = date1.value;
          this.end_date = date2.value;
      }
  }

  clearDate()
  {
      this.dateRangeStart.nativeElement.value = "";
      this.dateRangeEnd.nativeElement.value = "";
      this.start_date = '';
      this.end_date = '';
  }

  async searchPreplanCustomer(pageIndex,perpage)
  {
    if(!this.start_date && !this.end_date)
    {
      this.sharedapi.presentToast('Date is mandatory for getting Preplan Customer Data.');
    } else {
      this.paginator.pageIndex = pageIndex; 
      this.paginatorBottom.pageIndex = pageIndex;
      this.pageIndex = pageIndex;

      let qString = 'search='+this.search+'&date_range='+this.start_date+'-'+this.end_date;
      this.preplan_loading = true;
      this.preplan_loaded = false;
      await this.dentalapi.prePlanCustomerLists(this.paginator.pageIndex).subscribe((data:any) => {
        this.preplan_loading = false;
        this.preplan_loaded = true;
        this.preplanCustomerLists = [];
        if(data.status)
        {
            this.preplanCustomerLists = data.data;
        }
      }, error => {
        this.preplan_loading = false;
        this.preplan_loaded = true;
        this.sharedapi.checkError(error);
      });
    }
  }

  resetPreplanCustomerFilters()
  {
    this.search = '';
    this.clearDate();
    this.preplanCustomerLists = [];
  }

  /**********Plan Sent************ */
  planSentDateRangeChange(date1,date2)
  {
      if(date2.value)
      {
          this.paln_sent_start_date = date1.value;
          this.paln_sent_end_date = date2.value;
      }
  }

  planSentClearDate()
  {
      this.planSentDateRangeStart.nativeElement.value = "";
      this.planSentDateRangeEnd.nativeElement.value = "";
      this.paln_sent_start_date = '';
      this.paln_sent_end_date = '';
  }

  dateRangeChangeODS(date1,date2)
  {
      if(date2.value)
      {
          this.ods_start_date = date1.value;
          this.ods_end_date = date2.value;
      }
  }

  clearDateODS()
  {
      this.odsplanSentDateRangeStart.nativeElement.value = "";
      this.odsplanSentDateRangeEnd.nativeElement.value = "";
      this.ods_start_date = '';
      this.ods_end_date = '';
  }

  dateRangeChangeSnazzy(date1,date2)
  {
      if(date2.value)
      {
          this.snazzy_start_date = date1.value;
          this.snazzy_end_date = date2.value;
      }
  }

  clearDateSnazzy()
  {
      this.snazzyplanSentDateRangeStart.nativeElement.value = "";
      this.snazzyplanSentDateRangeEnd.nativeElement.value = "";
      this.snazzy_start_date = '';
      this.snazzy_end_date = '';
  }

  dateRangeChangeSOF(date1,date2)
  {
      if(date2.value)
      {
          this.sof_start_date = date1.value;
          this.sof_end_date = date2.value;
      }
  }

  clearDateSOF()
  {
      this.sofDateRangeStart.nativeElement.value = "";
      this.sofDateRangeEnd.nativeElement.value = "";
      this.sof_start_date = '';
      this.sof_end_date = '';
  }

  dateRangeChangeProduction(date1,date2)
  {
      if(date2.value)
      {
          this.production_start_date = date1.value;
          this.production_end_date = date2.value;
      }
  }

  clearDateProduction()
  {
      this.productionDateRangeStart.nativeElement.value = "";
      this.productionDateRangeEnd.nativeElement.value = "";
      this.production_start_date = '';
      this.production_end_date = '';
  }

  dateRangeChangeAlignerReceived(date1,date2)
  {
      if(date2.value)
      {
          this.ard_start_date = date1.value;
          this.ard_end_date = date2.value;
      }
  }

  clearDateAlignerReceived()
  {
      this.ardDateRangeStart.nativeElement.value = "";
      this.ardDateRangeEnd.nativeElement.value = "";
      this.ard_start_date = '';
      this.ard_end_date = '';
  }

  resetPlanSentFilters()
  {
    this.plan_sent_search = '';
    this.planSentClearDate();
    this.clearDate();
    this.clearDateODS();
    this.clearDateSnazzy();
    this.clearDateSOF();
    this.clearDateProduction();
    this.clearDateAlignerReceived();
    this.searchPlanSent(0,10);
  }
  

  public getServerData(event:PageEvent):any
  {
      this.perpage = event.pageSize;
      this.pageIndex = event.pageIndex;
      this.searchPlanSent(event.pageIndex,event.pageSize);
  }

  async searchPlanSent(pageIndex,perpage)
  {
    
    this.paginator.pageIndex = pageIndex; 
    this.paginatorBottom.pageIndex = pageIndex;
    this.pageIndex = pageIndex;
    let qString = 'plan_sent_search='+this.plan_sent_search+'&date_range='+this.paln_sent_start_date+'-'+this.paln_sent_end_date+'&approval_received_date='+this.start_date+'-'+this.end_date+'&ods_plan_received_date='+this.ods_start_date+'-'+this.ods_end_date+'&snazzy_plan_received_date='+this.snazzy_start_date+'-'+this.snazzy_end_date+'&sof_date='+this.sof_start_date+'-'+this.sof_end_date+'&production_date='+this.production_start_date+'-'+this.production_end_date+'&aligner_received_date='+this.ard_start_date+'-'+this.ard_end_date;


    this.plan_sent_loading = true;
    this.plan_sent_loaded = false;
    this.planSentLists = [];
    await this.dentalapi.planSentLists(this.paginator.pageIndex,perpage, qString).subscribe((data:any) => {
      this.length = data.totaldata;
      this.plan_sent_loading = false;
      this.plan_sent_loaded = true;
      
      if(data.status)
      {
          this.planSentLists = data.data;
      }
    }, error => {
      this.plan_sent_loading = false;
      this.plan_sent_loaded = true;
      this.sharedapi.checkError(error);
    });
  }

  exportPlanSentList()
  {
    if(this.planSentLists.length>0)
    {
            let data = [];
            let titles = [
              'Circle',
              'Customer Name',
              'Glamyo Patient ID',
              'Mobile',
              'Pro Name',
              'Total Payment Received',
              'Snazzy Plan Received Date',
              'ODS Plan Received Date',
              'Plan Sent At',
              'Plan Approved',
              'Plan Approval Date',
              'SOF Filled Date',
              'Sent to Production Date',
              'Total no of upper aligners',
              'Total no of Lower aligners',
              'Aligner received Date',
              'No of Upper Aligner Received',
              'No of Lower Aligner Received',
              'Remaining Upper Aligner',
              'Remaining Lower Aligner',
              'Dispatch Date',
              'Tracking ID',
              'Aligner Delivery Date',
              'Clinic Visit/VC Date'
            ];
            data.push(titles);
            for(let planSent in this.planSentLists)
            {
              let share_with_patient_on_date = '';
              if(this.planSentLists[planSent].share_with_patient_on) 
              {
                share_with_patient_on_date = formatDate(this.planSentLists[planSent].share_with_patient_on*1000, 'dd-MM-yyyy hh:mm a', 'en-US');
              }

              let payment_received = '';
              if(this.planSentLists[planSent].payment_status==1)
              {
                if(this.planSentLists[planSent].totalAmt-this.planSentLists[planSent].received_amt <= 0)
                {
                  payment_received = 'Yes';
                } 
                else
                {
                  payment_received = 'No';
                } 
              }
              else
              {
                payment_received = '-';
              }


              let exdata = [
                this.planSentLists[planSent].circle_name,
                this.planSentLists[planSent].lead_name,
                this.planSentLists[planSent].glamyo_patient_id,
                this.planSentLists[planSent].mobile,
                this.planSentLists[planSent].pro_name,
                payment_received,
                this.planSentLists[planSent].snazzy_plan_received_date ? formatDate(this.planSentLists[planSent].snazzy_plan_received_date*1000, 'dd-MM-yyyy hh:mm a', 'en-US'): '',
                this.planSentLists[planSent].ods_plan_received_date ? formatDate(this.planSentLists[planSent].ods_plan_received_date*1000, 'dd-MM-yyyy hh:mm a', 'en-US'): '',
                share_with_patient_on_date,
                this.planSentLists[planSent].approval_received == 1 ? 'Yes' : 'No',
                this.planSentLists[planSent].approval_received_date ? formatDate(this.planSentLists[planSent].approval_received_date*1000, 'dd-MM-yyyy', 'en-US'): '',
                this.planSentLists[planSent].sof_filled_date ? formatDate(this.planSentLists[planSent].sof_filled_date*1000, 'dd-MM-yyyy', 'en-US'): '',
                this.planSentLists[planSent].send_to_production_on ? formatDate(this.planSentLists[planSent].send_to_production_on*1000, 'dd-MM-yyyy', 'en-US'): '',
                this.planSentLists[planSent].upper_aligners,
                this.planSentLists[planSent].lower_aligners,
                this.planSentLists[planSent].aligner_received_on ? formatDate(this.planSentLists[planSent].aligner_received_on*1000, 'dd-MM-yyyy hh:mm a', 'en-US') : '',
                this.planSentLists[planSent].upper_aligner_received ? this.planSentLists[planSent].upper_aligner_received : 0,
                this.planSentLists[planSent].lower_aligner_received ? this.planSentLists[planSent].lower_aligner_received : 0,
                this.planSentLists[planSent].upper_aligners - this.planSentLists[planSent].upper_aligner_received,
                this.planSentLists[planSent].lower_aligners - this.planSentLists[planSent].lower_aligner_received,
                this.planSentLists[planSent].aligner_dispatched_date ? formatDate(this.planSentLists[planSent].aligner_dispatched_date*1000, 'dd-MM-yyyy', 'en-US'): '',
                this.planSentLists[planSent].tracking_id,
                this.planSentLists[planSent].aligner_delivery_date ? formatDate(this.planSentLists[planSent].aligner_delivery_date*1000, 'dd-MM-yyyy', 'en-US'): '',
                this.planSentLists[planSent].clinic_visit_required_on ? formatDate(this.planSentLists[planSent].clinic_visit_required_on*1000, 'dd-MM-yyyy hh:mm a', 'en-US') : '',
              ];
              data.push(exdata)
            }
            let ws = XLSX.utils.aoa_to_sheet(data);
            /* generate workbook and add the worksheet */
            const wb: XLSX.WorkBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

            /* save to file */
            let utc = new Date().toJSON().slice(0,10).replace(/-/g,'/');
            XLSX.writeFile(wb, 'plan_sent_list_'+utc+'.xlsx');
      }else{
          this.sharedapi.presentToast('Sorry! No data found for export.');
      }
  }
}
